
// src/reducers/dashboard-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'

import { 
  FETCH_DASHBOARD_SUMMARY,
  FETCH_DASHBOARD_SUMMARY_REQUESTED,
  FETCH_DASHBOARD_SUMMARY_COMPLETED,
  FETCH_DASHBOARD_SUMMARY_FAILED,
  FETCH_DASHBOARD_POSTS,
  FETCH_DASHBOARD_POSTS_REQUESTED,
  FETCH_DASHBOARD_POSTS_COMPLETED,
  FETCH_DASHBOARD_POSTS_FAILED,
  FETCH_DASHBOARD_REPLIES,
  FETCH_DASHBOARD_REPLIES_REQUESTED,
  FETCH_DASHBOARD_REPLIES_COMPLETED,
  FETCH_DASHBOARD_REPLIES_FAILED,
  FETCH_DASHBOARD_RECEIVES,
  FETCH_DASHBOARD_RECEIVES_REQUESTED,
  FETCH_DASHBOARD_RECEIVES_COMPLETED,
  FETCH_DASHBOARD_RECEIVES_FAILED,
  FETCH_DASHBOARD_DETAILS_REQUESTED,
  FETCH_DASHBOARD_DETAILS_COMPLETED,
  FETCH_DASHBOARD_DETAILS_FAILED,
  CLEAR_DASHBOARD_DATA,
  CLEAR_DASHBOARD_DETAILS,
} from '../actions/dashboard'

const initialState = {
  isSummaryFetching: false,
  isPostsFetching: false,
  isRepliesFetching: false,
  isReceivesFetching: false,
  isDetailsFetching: false,
  summary: undefined,
  posts: undefined,
  replies: undefined,
  receives: undefined,
  details: undefined,
}

export default function dashboardReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_DASHBOARD_SUMMARY_REQUESTED:
    return Object.assign({}, state, {
      isSummaryFetching: true,
    })

  case FETCH_DASHBOARD_POSTS_REQUESTED:
    return Object.assign({}, state, {
      isPostsFetching: true,
    })

  case FETCH_DASHBOARD_REPLIES_REQUESTED:
    return Object.assign({}, state, {
      isRepliesFetching: true,
    })

  case FETCH_DASHBOARD_RECEIVES_REQUESTED:
    return Object.assign({}, state, {
      isReceivesFetching: true,
    })

  case FETCH_DASHBOARD_DETAILS_REQUESTED:
    return Object.assign({}, state, {
      isDetailsFetching: true,
    })

  case FETCH_DASHBOARD_SUMMARY_FAILED:
    return Object.assign({}, state, {
      isSummaryFetching: false,
    })

  case FETCH_DASHBOARD_POSTS_FAILED:
    return Object.assign({}, state, {
      isPostsFetching: false,
    })

  case FETCH_DASHBOARD_REPLIES_FAILED:
    return Object.assign({}, state, {
      isRepliesFetching: false,
    })

  case FETCH_DASHBOARD_RECEIVES_FAILED:
    return Object.assign({}, state, {
      isReceivesFetching: false,
    })

  case FETCH_DASHBOARD_DETAILS_FAILED:
    return Object.assign({}, state, {
      isDetailsFetching: false,
    })

  case FETCH_DASHBOARD_SUMMARY_COMPLETED:
    return Object.assign({}, state, {
      isSummaryFetching: false,
      summary: action.results.summary,
    })

  case FETCH_DASHBOARD_POSTS_COMPLETED:
    return Object.assign({}, state, {
      isPostsFetching: false,
      posts: action.results.members,
    })

  case FETCH_DASHBOARD_REPLIES_COMPLETED:
    return Object.assign({}, state, {
      isRepliesFetching: false,
      replies: action.results.members,
    })

  case FETCH_DASHBOARD_RECEIVES_COMPLETED:
    return Object.assign({}, state, {
      isReceivesFetching: false,
      receives: action.results.members,
    })

  case FETCH_DASHBOARD_DETAILS_COMPLETED:
    return Object.assign({}, state, {
      isDetailsFetching: false,
      details: action.results,
    })

  case CLEAR_DASHBOARD_DATA:
    return initialState

  case CLEAR_DASHBOARD_DETAILS:
    return Object.assign({}, state, {
      isDetailsFetching: false,
      details: undefined,
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dashboard-reducer.js